/** @file Flattens a document handle to the rig's [ax, ay, bx, by] or [ax, ay, bx, by, cx, cy] (image px). */
import type { Handle } from '@pose2d/format/types';

type HandleJson = [number, number, number, number] | [number, number, number, number, number, number];

/** Image-pixel (y-down) handle points as the rig JSON stores them (§5.4). */
export function handleArray(h: Handle): HandleJson {
  return h.c === undefined ? [h.a[0], h.a[1], h.b[0], h.b[1]] : [h.a[0], h.a[1], h.b[0], h.b[1], h.c[0], h.c[1]];
}
